<form [formGroup]="forgotPasswordForm" class="login-container">
  <div class="header">Trouble Logging In?</div>
  <div class="subheader">Enter your email below and we will send you a link to get back into your account</div>
  <mat-form-field class="w-100-1">
    <mat-label>Email</mat-label>
    <input formControlName="email" matInput required type="email" />
    @if (forgotEmailErrorMessage) {
      <mat-error data-cy="email-validation-error">
        {{ forgotEmailErrorMessage }}
      </mat-error>
    }
  </mat-form-field>
  <div class="space-between-container">
    <button (click)="authMode = authModeEnum.login" color="primary" mat-stroked-button type="button">Cancel</button>
    <button (click)="sendResetEmail()" [disabled]="!forgotPasswordForm.valid" color="primary" mat-raised-button>
      Email Me a Reset Link
    </button>
  </div>
</form>
